import { render, staticRenderFns } from "./QuartersTable.vue?vue&type=template&id=55f1b728&scoped=true"
import script from "./QuartersTable.vue?vue&type=script&lang=js"
export * from "./QuartersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1b728",
  null
  
)

export default component.exports